// @flow
import { PRIMARY_COLOR } from 'coooltv-js-shared/src/styles/common';
import * as React from 'react';
import {
    StyleSheet, View, Text, ActivityIndicator, useWindowDimensions,
} from 'react-native';
import { FormattedMessage } from 'react-intl';
import { APIContext } from 'speed-js-react';
import MainWrapper from 'src/components/MainWrapper';
import StyledButton from 'src/components/StyledButton/StyledButton';
import Title from 'src/components/Title';
import { TRIAL_PERIOD_START } from 'src/navigation/constants';
import { GREY_COLOR } from 'src/styles/common';

const styles = StyleSheet.create({
    title: {
        fontFamily: 'Open Sans',
        fontSize: 24,
        color: GREY_COLOR,
        fontWeight: 300,
        paddingHorizontal: 150,
    },
    titlePhone: {
        fontFamily: 'Open Sans',
        fontSize: 20,
        color: GREY_COLOR,
        fontWeight: 300,
        paddingHorizontal: 20,
    },
    queueContainer: {
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: 70,
    },
    buttonView: {
        width: 500,
    },
    buttonViewPhone: {
        width: '90%',
    },
    spinner: {
        marginTop: 30,
    },
    borderTopView: {
        borderTopWidth: 1,
        borderRightStyle: 'solid',
        borderColor: PRIMARY_COLOR,
        marginTop: -2,
    },
});

let prefix = `${process.env.PUBLIC_URL}/`.replace('//', '/');
if (prefix.startsWith('/')) {
    prefix = prefix.substr(1);
}

const TrialPeriodQueue = (): React.Node => {
    const { apiClient } = React.useContext(APIContext);
    const { width } = useWindowDimensions();
    const [subscribingToQueue, setSubscribingToQueue] = React.useState(false);

    const subscribeToQueue = React.useCallback(() => {
        setSubscribingToQueue(true);
        apiClient.resources.currentAccounts.subscribeToTrialQueue()
            .then(() => {
                window.location = `/${prefix}${TRIAL_PERIOD_START}`;
            });
    }, [apiClient.resources.currentAccounts]);

    return (
        <View>
            <MainWrapper>
                <Title text={(
                    <FormattedMessage
                        id="too-many-trial-requests"
                        defaultMessage="We currently have too many requests"
                    />
                )}
                />
                <View style={styles.borderTopView}>
                    <View style={styles.queueContainer}>
                        <Text style={width > 600 ? styles.title : styles.titlePhone}>
                            <FormattedMessage
                                id="queue-trial-message"
                                defaultMessage="Thank you for your interest towards coool.tv! At the current moment, we
                                    have too many requests for a free trial period. If you desire, please
                                    subscribe to our queue - when your turn arrives, we will reserve
                                    a spot for you for 48 hours and we will send you an invite to activate
                                    your trial to your email."
                            />
                        </Text>
                        {!subscribingToQueue ? (
                            <View style={width > 600 ? styles.buttonView : styles.buttonViewPhone}>
                                <StyledButton
                                    handleSubmit={subscribeToQueue}
                                    text={(
                                        <FormattedMessage
                                            id="trial-period-request"
                                            defaultMessage="Trial period request"
                                        />
                                    )}
                                />
                            </View>
                        ) : (
                            <ActivityIndicator
                                size="large"
                                color={PRIMARY_COLOR}
                                style={styles.spinner}
                            />
                        )}
                    </View>
                </View>
            </MainWrapper>
        </View>
    );
};
export default TrialPeriodQueue;
